<template>
  <v-container fluid align-start ma-0 pa-2 class="epms4010-main container-height">
    <v-row no-gutters fill-height>
      <v-col cols="12">
        <i-card-vertical :headerTitle="menuTitle" >
          <template v-slot:body>
            <v-layout column >
              <v-row>
                <v-col cols="12" class="pa-0">
                  <i-card-top
                    class="d-md-flex"
                    outlined
                    :unUseBtnList="unUseBtnList"
                    :useBtnList="useBtnList"
                    @btnRetrieve="btnRetrieve" @btnPorSheet="btnPorSheet" @btnBomList="btnBomList"
                    @btnReceipt="btnReceipt" @btnPrintPo="btnPrintPo" @btnDelivery="btnDelivery" @btnPoList="btnPoList"
                    @btnSaveExcel="onExporting"
                    :key="useBtnListKey"
                  >
                    <template v-slot:body>
                      <v-row>
                        <v-col cols="12">
                        </v-col>
                      </v-row>
                    </template>
                  </i-card-top>
                </v-col>
              </v-row>
              <v-row dense class="form-layout">
                <v-col cols="12" class="pa-0">
                  <v-row no-gutters>
                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                      <span>PO No</span>
                    </v-col>
                    <v-col cols="3">
                      <v-text-field 
                        v-model="formData.poNo" 
                        dense 
                        outlined 
                        hide-details="auto"
                        backgroundColor="rgb(255,255,232)"
                        maxLength="30"
                        @keydown.enter="btnRetrieve()"
                      />
                    </v-col>
                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                      <span>Ship No</span>
                    </v-col>
                    <v-col cols="7">
                      <v-text-field 
                        v-model="formData.shipNo" 
                        dense 
                        outlined 
                        hide-details="auto"
                        readonly
                      />
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                      <span>Quotation No</span>
                    </v-col>
                    <v-col cols="3">
                      <v-text-field 
                        v-model="formData.QuotationNo" 
                        dense 
                        outlined 
                        hide-details="auto"
                        backgroundColor="rgb(255,255,232)"
                        readonly
                      />
                    </v-col>
                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                      <span>Supplier</span>
                    </v-col>
                    <v-col cols="3">
                      <v-text-field 
                        v-model="formData.supplier" 
                        dense 
                        outlined 
                        hide-details="auto"
                        readonly
                      />
                    </v-col>
                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                      <span>PO Amount</span>
                    </v-col>
                    <v-col cols="1/2">
                      <v-text-field 
                        v-model="formData.amount" 
                        dense 
                        outlined 
                        hide-details="auto"
                        readonly
                        backgroundColor="rgb(255,255,232)"
                        style="fontWeight:bold;"
                      />
                    </v-col>
                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                      <span>VAT</span>
                    </v-col>
                    <v-col cols="1/2">
                      <v-text-field 
                        v-model="formData.vat" 
                        dense 
                        outlined 
                        hide-details="auto"
                        readonly
                        backgroundColor="rgb(255,255,232)"
                        style="fontWeight:bold;"
                      />
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                      <span>Charger</span>
                    </v-col>
                    <v-col cols="3">
                      <v-text-field 
                        v-model="formData.charger" 
                        dense 
                        outlined 
                        hide-details="auto"
                        readonly
                      />
                    </v-col>
                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                      <span>FAX</span>
                    </v-col>
                    <v-col cols="3">
                      <v-text-field 
                        v-model="formData.fax" 
                        dense 
                        outlined 
                        hide-details="auto"
                        readonly
                      />
                    </v-col>
                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                      <span>Trans. Fee</span>
                    </v-col>
                    <v-col cols="1/2">
                      <v-text-field 
                        v-model="formData.transFee" 
                        dense 
                        outlined 
                        hide-details="auto"
                        readonly
                        backgroundColor="rgb(255,255,232)"
                        style="fontWeight:bold;"
                      />
                    </v-col>
                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                      <span>Trans. VAT</span>
                    </v-col>
                    <v-col cols="1/2">
                      <v-text-field 
                        v-model="formData.transVat" 
                        dense 
                        outlined 
                        hide-details="auto"
                        readonly
                        backgroundColor="rgb(255,255,232)"
                        style="fontWeight:bold;"
                      />
                    </v-col>
                  </v-row>

                  <v-row no-gutters>
                    <v-col cols="4" >
                      <v-row no-gutters class="row__select-no">
                        <v-col cols="3" align="right" class="pr-2 pt-2 formHeader">
                          <span>Request<br>Employee</span>
                        </v-col>
                        <v-col cols="9" class="quotNo">
                          <v-text-field 
                            v-model="formData.request" 
                            outlined 
                            hide-details="auto"
                            readonly
                            height="60"
                          />
                        </v-col >                        
                      </v-row>
                    </v-col>
                    <v-col cols="4" class="quotNo">
                      <v-row no-gutters >
                        <v-col cols="3" align="right" class="pb-1 pr-2 pt-1 formHeader" >
                          <span >Transport</span>
                        </v-col>
                        <v-col cols="9">
                          <v-text-field 
                            v-model="formData.transport" 
                            dense 
                            outlined 
                            hide-details="auto"
                            readonly
                          />
                        </v-col>
                      </v-row>
                      <v-row no-gutters class="row__select-no">
                        <v-col cols="3" align="right" class="pb-1 pr-2 pt-1 formHeader">
                          <span>Payment</span>
                        </v-col>
                        <v-col cols="9">
                          <v-text-field 
                            v-model="formData.payment" 
                            dense 
                            outlined 
                            hide-details="auto"
                            readonly
                          />
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="4" class="quotNo">
                      <v-row no-gutters >
                        <v-col cols="3" align="right" class="pb-1 pr-2 pt-1 formHeader">
                          <span>Gov. Fee</span>
                        </v-col>
                        <v-col cols="9" align="right">
                          <v-text-field 
                            v-model="formData.govFee" 
                            dense 
                            outlined 
                            hide-details="auto"
                            readonly
                            backgroundColor="rgb(255,255,232)"
                            style="fontWeight:bold;"
                          />
                        </v-col>
                      </v-row>
                      <v-row no-gutters class="row__select-no">
                        <v-col cols="3" align="right" class="pb-1 pr-2 pt-1 formHeader">
                          <span>Total</span>
                        </v-col>
                        <v-col cols="9" align="right">
                          <v-text-field 
                            v-model="formData.total" 
                            dense 
                            outlined 
                            hide-details="auto"
                            readonly
                            backgroundColor="rgb(255,255,232)"
                            style="fontWeight:bold;"
                          />
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="12" class="pt-1">
                  <DxDataGrid id="epms4010" 
                    class="hipGridHeight5_2" 
                    :ref="epms4010Ref"
                    :data-source="gridMainList" 
                    :remote-operations="false" 
                    :hover-state-enabled="true"
                    :allow-column-resizing="true" 
                    :allow-column-reordering="true"
                    :row-alternation-enabled="true" 
                    :show-borders="true" 
                    :width="grid.width"
                    :show-row-lines="true" 
                    key-expr="id" 
                    :focused-row-enabled="true"
                    :column-hiding-enabled="false" 
                    :selection="{ mode: 'none' }"                                        
                    @cellPrepared="cellPrepared"                    
                  >                                                       
                    <DxPaging :enabled=true :page-size="10" />
                   
                    <DxColumn data-field="no" caption="No" width="3%" data-type="string" alignment="center" :allow-editing="false" />
                    <DxColumn caption="Ship No" width="10%" data-type="string" alignment="center" :allow-editing="false" >
                      <DxColumn data-field="shipNo" caption="POR No" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                    </DxColumn>
                    <DxColumn data-field="matlCd" caption="Material Code" width="10%" data-type="left" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="matlSpec" caption="Material Specification" width="28%" data-type="left" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="matlUnit" caption="Unit" width="5%" data-type="string" alignment="center" :allow-editing="false" />
                    <DxColumn caption="P.O. Qty" width="9%" data-type="string" alignment="right" :allow-editing="false" >
                      <DxColumn data-field="poQty" caption="Unit Price" width="9%" data-type="string" alignment="right" :allow-editing="false"/>
                    </DxColumn>
                    <DxColumn caption="P.O. Amount" width="9%" data-type="string" alignment="right" :allow-editing="false" >
                      <DxColumn data-field="poAmt" caption="Trans. Fee" width="9%" data-type="string" alignment="right" :allow-editing="false" />
                    </DxColumn>
                    <DxColumn caption="VAT" width="3%" data-type="string" alignment="center" :allow-editing="false" >
                      <DxColumn data-field="poVat" caption="VAT" width="3%" data-type="string" alignment="center" :allow-editing="false" />
                    </DxColumn>

                    <DxColumn data-field="suppDlyDte" width="10%" data-type="string" alignment="center" :allow-editing="false" header-cell-template="headerTemplate" />
                    <template #headerTemplate>
                      <div>Supp. Plan<br>Delivery Date</div>
                    </template>

                    <DxColumn caption="W/H Req. Date" width="10%" data-type="string" alignment="center" :allow-editing="true" >
                      <DxColumn data-field="whReqDte" caption="Req. Dely. Date" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                    </DxColumn>

                    <DxColumn data-field="certYn" caption="Cert Y/N" width="5%" data-type="string" alignment="center" :allow-editing="false" />                    
                  </DxDataGrid>

                  <DxDataGrid id="epms4010xls" 
                    class="hipGridHeight5_2" 
                    :ref="epms4010XlsRef"
                    :data-source="gridMainListXls" 
                    :remote-operations="false"         
                    :width="grid.width"                    
                    key-expr="id"                     
                    :column-hiding-enabled="false" 
                    :selection="{ mode: 'none' }"  
                    :style="'display: none;'"                    
                    @exporting="onExporting"                   
                  >         
                    <DxExport :enabled="true" />                                                                                        
                    <DxColumn data-field="shipNo" caption="Ship No" width="10%" data-type="string" alignment="center" :allow-editing="false" />                                          
                    <DxColumn data-field="porNo" caption="POR No" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="matlCd" caption="Material Code" width="10%" data-type="left" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="matlSpec" caption="Material Specification" width="28%" data-type="left" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="matlUnit" caption="Unit" width="5%" data-type="string" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="poQty" caption="P.O. Qty" width="9%" data-type="string" alignment="right" :allow-editing="false" />                                          
                    <DxColumn data-field="uprice" caption="Unit Price" width="9%" data-type="string" alignment="right" :allow-editing="false"/>
                    <DxColumn data-field="poAmt" caption="P.O. Amount" width="9%" data-type="string" alignment="right" :allow-editing="false" />                                          
                    <DxColumn data-field="poVat" caption="P.O VAT" width="3%" data-type="string" alignment="center" :allow-editing="false" />                                          
                    <DxColumn data-field="transFee" caption="Trans. Fee" width="9%" data-type="string" alignment="right" :allow-editing="false" />                    
                    <DxColumn data-field="transVat" caption="Trans. VAT" width="3%" data-type="string" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="suppDlyDte" caption="Supp. Plan Delivery Date" width="10%" data-type="string" alignment="center" :allow-editing="false" />                   
                    <DxColumn data-field="whReqDte" caption="W/H Req. Date" width="10%" data-type="string" alignment="center" :allow-editing="false" />                                          
                    <DxColumn data-field="reqDlyDte" caption="Req. Dely. Date" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="certYn" caption="Cert Y/N" width="5%" data-type="string" alignment="center" :allow-editing="false" />                    
                  </DxDataGrid>
                </v-col>               
              </v-row>
              <v-row v-if="filePath != null && filePath != '' ? true : false">                
                    <v-icon color="blue">$folder</v-icon><span class="pl-1 drawing" @click="fileOpen">View Attached File</span>  
              </v-row>
              <v-row v-if="dwgCount > 0 ? true : false">
                    <v-icon color="blue">$folder</v-icon><span class="pl-1 drawing" @click="drawingPage">View Drawing Page</span>
              </v-row>
            </v-layout>
          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
    <drawingPagePop v-if="showPop" :showPop.sync="showPop" :paramNo="poNo" :gbn="'PO'" />
  </v-container>
</template>

<script>
import { DxDataGrid, DxEditing, DxColumn  } from 'devextreme-vue/data-grid'
import ICardVertical from '@/components/common/iCardVertical.vue'
import iCardTop from '@/components/common/iCardTop.vue'
import baseview from '@/components/base/baseview.vue' // base page 추가
import BaseDataGrid from '@/components/base/BaseDataGrid.vue' // 데이타 그리드 사용시 베이스 추가
import notify from 'devextreme/ui/notify' // message
import { getPoDetail , getPoDetailGrid } from '@/api/view/hip/4/epms4010.js'
import { getDwgCountByPO } from '@/api/view/hip/common/common.js'
import { ftpDownload} from '@/api/view/hip/common/common.js'
import { getNumComma } from '@/utils/common.js'
import { getPoReceive } from '@/api/view/hip/4/epms4000.js'
import drawingPagePop from '@/views/hip/common/drawingPagePop';
import { reportView } from '@/api/view/hip/common/common.js'
import {DxExport } from 'devextreme-vue/data-grid'
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';
import { exportDataGrid } from 'devextreme/excel_exporter';

export default {
  name: 'epms4010',
  mixins: [baseview, BaseDataGrid],
  components: {
    ICardVertical,
    'i-card-top': iCardTop,
    DxDataGrid,
    DxExport,
    DxColumn,
    DxEditing,
    drawingPagePop
  },
  data() {
    return {
      menuTitle: this.$route.meta.title,
      unUseBtnList:[],
      useBtnList:['btnPorSheet', 'btnBomList', 'btnRetrieve', 'btnReceipt', 'btnPrintPo', 'btnDelivery', 'btnPoList','btnSaveExcel'],
      useBtnListTemp:[ 'btnPorSheet', 'btnBomList', 'btnRetrieve', 'btnReceipt', 'btnPrintPo', 'btnDelivery', 'btnPoList','btnSaveExcel' ],
      useBtnListKey: 0,
      formData: {
        poNo: '' , shipNo: '', QuotationNo: '', supplier: '', amount: '', charger: '', fax: '', transFee: '' ,transport: '', 
        payment: '', govFee: '', total: '' ,request: '' , vat: '' , transVat: ''

      },
      epms4010Ref: 'epms4010Ref',
      epms4010XlsRef: 'epms4010XlsRef',
      gridMainList: [],
      gridMainListXls: [],
      //cell merge
      mergeElements: [],
      mergeStartElements: [],

      nonDispalyedRowIndex: [],
      curRowIndex: 0,

      poNo: '',
      dwgCount: 0,
      filePath: '',
      showPop: false,
      sys: this.$store.state.system.sysCd,
      receiveYn: 'N'

    }
  },
  computed: {
    gridMainInstance() {
      return this.GetDataGrid(this.epms4010Ref)
    },
  },
  mounted() {
    this.gridMainInstance.option('defaultPaging', false)
    if(this.$route.params.poNo){
      this.poNo = this.$route.params.poNo
      this.gridMainList = []
      this.doSearchDwg()
      this.doSearchMain()
      this.doSearchGrid()
    }
  },
  methods: {
    FuncGetDataGrid() {
      const gridInstance = this.$refs.epms4010XlsRef.instance;
      if (gridInstance) {
        return gridInstance; // Lấy data hiện tại
      }
      return null;
    },
    async doSearchDwg(){
      let params = {
        poNo: this.poNo,
      }
      await getDwgCountByPO(params)
      .then( res => {
        this.dwgCount = res.list[0].tcnt
      }).catch(error => {})
    },
    async doSearchMain(){
      this.openLoading('searching')
      let params = {
        makerCd: this.$store.state.user.makerCd,
        poNo: this.poNo,
      }
      await getPoDetail(params).then(res => {
        if(res.list.length){
          let list = res.list[0]
          this.formData = {
            poNo: list.poNo , shipNo: list.shipNm, QuotationNo: list.quotNo, supplier:list.custNm, amount: getNumComma(list.poAmt), 
            vat: getNumComma(list.poVat), charger:list.buyerNm, fax: list.custFax, transFee: getNumComma(list.transFee) ,transVat: getNumComma(list.transVat),
            transport: list.transCondDesc, payment: list.payCondDesc, govFee: getNumComma(list.govFee), total: getNumComma(list.totAmt) + ' ' + list.moneUnit ,request: list.reqDept
          }
          this.receiveYn = list.receiveYn
          this.filePath = list.filePath
        }
        this.setBtnList()
      }).finally(() => {
        this.endLoading()
      })
    },
    async doSearchGrid(){
      this.gridMainList = []
      this.openLoading('searching')
      let params = {
        makerCd: this.$store.state.user.makerCd,
        poNo: this.poNo,
      }
      await getPoDetailGrid(params).then(res => {
        if(res.list.length){
          let no = 1;
          let cnt = 1;
          this.gridMainListXls = res.list 
          res.list.forEach(e => {
            this.gridMainList.push(
              {
                no: no, shipNo: e.shipNo, matlCd: e.matlCd, matlSpec: e.matlSpec, matlUnit: e.matlUnit, poQty: getNumComma(e.poQty), poAmt: getNumComma(e.poAmt), 
                poVat: getNumComma(e.poVat), suppDlyDte: e.suppDlyDte, whReqDte: e.whReqDte, certYn: e.certYn, id: cnt++
              },
              {
                no: no, shipNo: e.porNo, matlCd: e.matlCd, matlSpec: e.matlSpec, matlUnit: e.moneUnit, poQty: getNumComma(e.poUprice), poAmt: getNumComma(e.transFee), 
                poVat: getNumComma(e.transVat), suppDlyDte: e.suppDlyDte, whReqDte: e.reqDlyDte, certYn: e.certYn, id: cnt++
              }
            )
            no++
          });
        }
      }).finally(() => {
        this.endLoading()
      })
    },
    onExporting(e) {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('PO Detail');

      let gridInstance = this.FuncGetDataGrid();
      
      gridInstance.element().style.display = 'block';

      exportDataGrid({
        component: gridInstance,//this.gridMainInstance,
        worksheet,
        topLeftCell: { row: 1, column: 1 },
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), '('+ this.poNo +')PO Detail.xlsx');
        });
      }).finally(()=>{
        gridInstance.element().style.display = 'none';
      });
      //this.gridMainInstance.cancel = true;
      gridInstance.cancel = true;
    },
    cellPrepared(e){
      if (e.rowType === 'data') {       
        //this.merge('no', this.mergeElements, this.mergeStartElements, e)
        // if(e.column.dataField === 'matlSpec'){
        //   e.cellElement.style['text-align'] = 'left'
        // }
         if (e.column.dataField === 'no' || e.column.dataField === 'matlCd' || e.column.dataField === 'matlSpec' || e.column.dataField === 'suppDlyDte'  || e.column.dataField === 'certYn'  ) {          
           if (e.value == e.component.cellValue(e.rowIndex + 1, e.column.dataField) && e.values[0] == e.component.cellValue(e.rowIndex + 1, 'no')) {
            e.cellElement.setAttribute('rowspan', 2)
           } else {
            e.cellElement.style.display = 'none'
          }
         }
        }
      },
    // merge(filed, mergeEle, mergeEleStart, e){
    //   if (e.column.dataField === filed || e.column.dataField === 'matlCd' || e.column.dataField === 'matlSpec' || e.column.dataField === 'suppDlyDte'
    //       || e.column.dataField === 'cert' ) {
    //     e.cellElement.style['vertical-align'] = 'middle'
    //     if (this.curRowIndex + 1 !== this.gridMainList.length) {
    //       if (e.rowIndex > 0) {
    //         // If the value of the previous row and the current value match, and the value of no is also the same
    //         if (e.component.cellValue(e.rowIndex - 1, e.column.dataField) == e.value && e.column.dataField === filed ) {
    //           if (e.component.cellValue(e.rowIndex - 1, e.column.dataField)) {
    //             // when value is not blank
    //             var prev = mergeEle[e.rowIndex - 1]
    //             if (!mergeEle[e.rowIndex]) {
    //               mergeEle[e.rowIndex] = {}
    //             }
    //             mergeEle[e.rowIndex] = prev
    //             mergeEleStart[e.rowIndex] = prev
    //             if (prev) {
    //               let curCellElement = e.cellElement
    //               curCellElement.style.display = 'none'

    //               var span = prev.getAttribute('rowspan')
    //               if (span) {
    //                 prev.setAttribute('rowspan', Number(span) + 1)
    //               } else {
    //                 prev.setAttribute('rowspan', 2)
    //               }
    //               this.nonDispalyedRowIndex.push(e.rowIndex)
    //             }
    //           } else {
    //             // when value is blank
    //             if (!mergeEle[e.rowIndex]) mergeEle[e.rowIndex] = {}
    //             mergeEle[e.rowIndex] = e.cellElement
    //           }
    //         } else {
    //           // If the value of the previous row is different from the current value
    //           if (!mergeEle[e.rowIndex]) mergeEle[e.rowIndex] = {}
    //           mergeEle[e.rowIndex] = e.cellElement
    //         }
    //       } else {
    //         // When index is 0
    //         if (!mergeEle[e.rowIndex]) {
    //           mergeEle[e.rowIndex] = {}
    //         }
    //         mergeEle[e.rowIndex] = e.cellElement
    //       }
    //       this.curRowIndex = e.rowIndex
    //     } else {
    //       // When everything is running and clicked
    //       if (this.nonDispalyedRowIndex.indexOf(e.rowIndex) !== -1) {
    //         e.cellElement.style.display = 'none'
    //       } else {
    //         if (typeof mergeEleStart[e.rowIndex + 1] === 'undefined') return
    //         let rowspan = mergeEleStart[e.rowIndex + 1].getAttribute('rowspan')
    //         e.cellElement.setAttribute('rowspan', rowspan)
    //       }
    //     }
    //     // To remove duplication of nonDispalyedRowIndex
    //     const set = new Set(this.nonDispalyedRowIndex)
    //     this.nonDispalyedRowIndex = [...set]
    //   }
    // },
    btnRetrieve(){
      this.gridMainList = []
      this.poNo = this.formData.poNo
      this.doSearchMain()
      this.doSearchGrid()
    },
    btnPorSheet(){
      const param = {
        fileName: 'por_sheet.jrxml',
        as_quot_no: this.formData.poNo
      }
      this.openLoading('searching')
      reportView(param)
      .finally(() => {
        this.endLoading()
      })
    },
    btnBomList(){
      const param = {
        fileName: 'bom_list.jrxml',
        as_quot_no: this.formData.poNo
      }
      this.openLoading('searching')
      reportView(param)
      .finally(() => {
        this.endLoading()
      })
    },
    btnReceipt(){
      let params = {
        quotNo: this.formData.QuotationNo,
        makerCd: this.$store.state.user.makerCd,
        userId: this.$store.state.user.userId
      }
      this.vToastifyPrompt(
        this.$t('Do you want to Receipt the Purchase Order?'),
        'info',
          current => {
            this.openLoading('searching')
            getPoReceive(params)
              .then(res => {
                if(res.list[0].ret == 'Y'){
                  notify(this.$t('Receipt PO is completed.'), 'success', 3000)
                  this.doSearchMain()
                } else {
                  this.vToastify(this.$t('An error has occured while updating receive information.'), 'warn')
                }
              })
              .catch(error => {
                this.vToastify(error, 'warn')
                this.endLoading()
              })
              .finally(() => {
                this.endLoading()
              })
          },
          null,
          true
        )
    },
    btnPrintPo(){
      const param = {
        fileName: 'epms4010.jrxml',
        as_po_no: this.poNo,
        as_maker_cd: this.$store.state.user.makerCd
      }
      this.openLoading('searching')
      reportView(param)
      .finally(() => {
        this.endLoading()
      })
    },
    btnDelivery(){
      this.$router.push('epms5010')
    },
    btnPoList(){
      if(this.$route.params.stDte){
        this.$router.push({name: 'epms4000' , params:{stDte: this.$route.params.stDte , edDte: this.$route.params.edDte , porNo: this.$route.params.porNo}})
      }else{
        this.$router.push('epms4000')
      }
    },
    drawingPage(){
      this.showPop = true
    },
    setBtnList() {
      let btnTemp = this.$_.cloneDeep(this.useBtnListTemp)

      if(this.receiveYn === 'Y') {
        this.unUseBtnList.push('btnReceipt')
      }

      if(this.poNo === '' || !this.poNo) {
        btnTemp = this.$_.filter(btnTemp, function(btnTemp) {
          return btnTemp !== 'btnPrintPo'
        })
      }

      this.useBtnList = btnTemp
      this.useBtnListKey++
    },
    fileOpen(e){
      let file = this.filePath
      this.openLoading('searching')
      ftpDownload(file)
      .finally(() => {
        this.endLoading()
      })

    }
  }
}
</script>
<style lang="scss" scoped>
.form-layout::v-deep .col {
  border-width: 1px 0 0 1px;
  border-style: solid;
  border-color: gray;
  
  * {
    border: 0px none !important;
  }

  .row:not(.row__select-no) {
    border-width: 0 0 1px 0 !important;
    border-style: solid !important;
    border-color: gray !important;
  }

  .col:not(.quotNo) {
    border-width: 0 1px 0 0 !important;
    border-style: solid !important;
    border-color: gray !important;
  }
}
.formHeader {
  background-color: rgb(223, 227, 213);
  font-weight: bold;
  color: black;
}
.formHeader2 {
  border-width: 0 0 0 0 !important;
  border-style: solid !important;
  border-color: gray !important;
}
.drawing {
  font-size: 10pt;
  color: black;
  cursor: pointer;
}
.drawing:hover{
  color: #4980BC;
}
</style>